import Vue from 'vue'
import Router from 'vue-router'
import { mapGetters, mapState } from 'vuex'
// import Storage from '@/utils/storage'

Vue.use(Router)

export default {
  created: function () {
  },
  computed: {
    ...mapGetters( [ 'selectedEnv', 'envList', 'tangoStatus', 'theme' ] ),
    ...mapState({ configList: state => state.user.config }),
    loginLogo() {
      let logo = ''
      if (this.configList && this.configList.length) {
        let idx = this.configList.findIndex(item => item.name === 'loginLogo')
        if (idx !== -1) logo = this.configList[idx].data ? this.configList[idx].data : ''
      }
      return logo
    },
    loginLogoStyle() {
      return {
        'background-image': 'url(' + this.loginLogo + ')'
      }
    },
    mainLogo() {
      let logo = ''
      if (this.configList && this.configList.length) {
        let idx = this.configList.findIndex(item => item.name === 'mainLogo')
        if (idx !== -1) logo = this.configList[idx].data ? this.configList[idx].data : ''
      }
      return logo
    },
    mainLogoStyle() {
      return {
        'background-image': 'url(' + this.mainLogo + ')'
      }
    },
    titleLogo() {
      let logo = ''
      if (this.configList && this.configList.length) {
        let idx = this.configList.findIndex(item => item.name === 'titleLogo')
        if (idx !== -1) logo = this.configList[idx].data ? this.configList[idx].data : ''
      }
      return logo
    },
    titleLogoStyle() {
      return {
        'background-image': 'url(' + this.titleLogo + ')'
      }
    }
  }
}
